import getStore from '../store/store';
export default function getComposeLinkViewState(linkId) {
    var store = getStore();
    return store.composeLinks.get(linkId);
}
//# sourceMappingURL=getComposeLinkViewState.js.map